import * as marietta from '../../..';
import { Matrix3D, Point, SVGMatrixParam } from '../../../core';
import { Defines, Stage } from '../../model';

import { EventDispatcher } from '../events';
import SVGSpriteManager from './SVGSpriteManager';

export default class SVGSprite extends EventDispatcher {
  public parent: SVGSprite;

  private _itemId: string;

  private children: SVGSprite[];

  private mtxRot: Matrix3D;

  private mtxScale: Matrix3D;

  private updateRotation: boolean;

  private updateScale: boolean;

  public element: HTMLElement;

  // public jQueryObject: JQuery;

  // public htmlElement: HTMLElement;

  public name: string;

  public x: number;

  public y: number;

  public isReverse: boolean;

  private _rotation: number;

  private _visible: boolean;

  private _scaleX: number;

  private _scaleY: number;

  private _alpha: number;

  private _width: number;

  private _height: number;

  private defaultWidth: number;

  private defaultHeight: number;

  public isEmpty: boolean;

  // 自身のスケールが変更された時、親がもつDefタグを更新するかどうか
  public bindParentDefine: boolean;

  private defineTag: SVGGElement[];

  private _mouseEnabled: boolean;

  private _doubleClickEnabled: boolean;

  private mouseDownHandler: any;

  private mouseUpHandler: any;

  private wheelHandler: any;

  private clickHandler: any;

  /*
   * isEmpty:trueの場合はタグの操作は一切せずに
   * mouseX/mouseYのみ取得したい場合のみ
   * アイテムコントローラなどで使用
   * width/heightは使えない
   */
  constructor(svg: Element = null, isEmpty: boolean = false) {
    super();

    // this.element = svg;
    // this.jQueryObject = svg;

    this.mtxRot = new Matrix3D();
    this.mtxScale = new Matrix3D();
    this.updateScale = false;
    this.isReverse = false;

    this.children = [];

    this.isEmpty = isEmpty;

    if (isEmpty) {
      this.x = 0;
      this.y = 0;
      this._scaleX = 1;
      this._scaleY = 1;
      this._width = 1;
      this._height = 1;
      this.defaultWidth = this._width / this.scaleX;
      this.defaultHeight = this._height / this.scaleY;
    } else {
      if (svg == null) {
        // svgが未指定の場合は空タグを生成
        // this.jQueryObject = $('<g class="item"></g>');
        const gelm:Element = document.createElementNS('http://www.w3.org/1999/xhtml', 'g');
        gelm.classList.add('item');
        this.element = gelm as HTMLElement;
        // const gelm:Element = document.createElementNS( 'http://www.w3.org/1999/xhtml', 'g');
        // gelm.classList.add('item');
        // this.htmlElement = gelm as SVGElement;

        this.defaultWidth = 1;
        this.defaultHeight = 1;
        this._width = this.defaultWidth;
        this._height = this.defaultHeight;
      } else if (svg.classList.contains('svgSprite')) {
        // すでにhtmlに存在している<g>タグの場合
        // もしくはアイテムの子要素をgetChildByNameで取り出す場合

        const param: SVGMatrixParam = Matrix3D.convertMatrixString(svg.getAttribute('transform'));

        this.x = param.x;
        this.y = param.y;
        this._scaleX = param.scaleX;
        this._scaleY = param.scaleY;

        if (svg.getAttribute('defaultWidth')) {
          this._width = parseFloat(svg.getAttribute('defaultWidth'));
          this._height = parseFloat(svg.getAttribute('defaultHeight'));
          this.defaultWidth = this._width / this.scaleX;
          this.defaultHeight = this._height / this.scaleY;
        }

        this.element = svg as HTMLElement;
        // this.jQueryObject = svg;
      } else {
        // 別途svgファイルから読み込んだ場合
        // item要素と定義要素を分ける

        const itemId: string = svg.getAttribute('itemId');

        if (itemId) {
          this.defaultWidth = parseFloat(svg.getAttribute('defaultWidth'));
          this.defaultHeight = parseFloat(svg.getAttribute('defaultHeight'));
          this._width = this.defaultWidth;
          this._height = this.defaultHeight;

          this.element = svg.querySelector(`g.g_${itemId}`);
          // this.jQueryObject = svg.find(`g.g_${itemId}`);

          const defines: SVGGElement[] = Array.from(svg.querySelectorAll(`g.defs_${itemId}`));

          // const define: any = svg.find(`g.defs_${itemId}`);

          if (defines.length > 0) {
            const uniqueIndex: number = SVGSpriteManager.instance.appendItem();

            for (let i:number = 0; i < defines.length; i += 1) {
              const define:SVGGElement = defines[i];

              define.setAttribute('class', `${define.getAttribute('class')}_${uniqueIndex}`);

              // ユニークなdefになるようid/hrefをリネームする

              for (let j:number = 0; j < define.children.length; j += 1) {
                define.children[j].setAttribute('id', `${define.children[j].getAttribute('id')}_${uniqueIndex}`);
              }
              // define.children().each((index: number, elem: Element): void => {
              //   // Debugger.log(">> " + $(elem).attr("id"));
              //   $(elem).attr('id', `${$(elem).attr('id')}_${uniqueIndex}`);
              // });
            }

            const useElements = this.element.querySelectorAll('use');

            for (let i: number = 0; i < useElements.length; i += 1) {
              const elem: SVGUseElement = useElements[i];
              const href: string = elem.getAttribute('xlink:href');
              elem.setAttribute('xlink:href', `${href}_${uniqueIndex}`);
            }

            const con:Element = document.querySelector(Defines.SVG_DEFINE_CONTAINER);

            for (let i:number = 0; i < defines.length; i += 1) {
              con.appendChild(defines[i]);
            }
            // $(enirva.webcad.model.Defines.SVG_DEFINE_CONTAINER).append(define);
            this.defineTag = defines;
          }

          const str: string = this.element.getAttribute('transform');

          const param: SVGMatrixParam = Matrix3D.convertMatrixString(str);
          // Debugger.log(param.x + "/" + param.y + "/" + param.scaleX + "/" + param.scaleY);

          this.x = param.x;
          this.y = param.y;
          this._scaleX = param.scaleX;
          this._scaleY = param.scaleY;

          this._itemId = itemId;
        } else {
          // お部屋などはこちらに行く

          this.x = 0;
          this.y = 0;
          this._scaleX = 1;
          this._scaleY = 1;

          // Siteなどアイテムリストにないもの
          this.element = svg as HTMLElement;
          // this.jQueryObject = svg;
        }
      }

      this.rotation = 0;

      if (Number.isNaN(this.x)) {
        this.x = 0;
      }

      if (Number.isNaN(this.y)) {
        this.y = 0;
      }

      if (Number.isNaN(this.scaleX)) {
        // WEBCAD-1086 建具エラーの修正
        // scaleを0にしてはいけない
        this.scaleX = 1;
      }

      if (Number.isNaN(this.scaleY)) {
        // WEBCAD-1086 建具エラーの修正
        // scaleを0にしてはいけない
        this.scaleY = 1;
      }
    }
  }

  public set mouseEnabled(flag: boolean) {
    this._mouseEnabled = flag;

    if (flag) {
      this.element.style.pointerEvents = 'auto';
    } else {
      this.element.style.pointerEvents = 'none';
    }
  }

  public get mouseEnabled(): boolean {
    return this._mouseEnabled;
  }

  private doubleClickListenerFunc: any;

  public set doubleClickEnabled(flag: boolean) {
    if (this._doubleClickEnabled !== flag) {
      if (flag) {
        // const scope: SVGSprite = this;

        let count: number = 0;
        let timer: number;

        window.addEventListener(
          'mouseup',
          this.doubleClickListenerFunc = (): void => {
            // e.preventDefault();
            const rect: DOMRect = this.getBoundingClientRect();
            // Debugger.log("win up " + scope.name + " >> " + rect.left + " " + rect.right + " " + Stage.mouseX);

            if (rect.left < Stage.mouseX && rect.right > Stage.mouseY && rect.top < Stage.mouseY && rect.bottom > Stage.mouseY) {
              count += 1;
              if (count === 1) {
                timer = window.setTimeout((): void => {
                  count = 0;
                }, 250);
              } else if (count >= 2) {
                // Debugger.log("double click!!");
                window.clearTimeout(timer);
                count = 0;

                this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.DOUBLE_CLICK));
              }
            }
          },
        );
      } else {
        window.removeEventListener('mouseup', this.doubleClickListenerFunc);
        this.doubleClickListenerFunc = null;
      }
    }
    this._doubleClickEnabled = flag;
  }

  public get doubleClickEnabled(): boolean {
    return this._doubleClickEnabled;
  }

  /*
   * Empty用に疑似パラメータをセット
   */
  public setEmptyParam(spt: SVGSprite): void {
    this.x = spt.x;
    this.y = spt.y;
    this.defaultWidth = spt.defaultWidth;
    this.defaultHeight = spt.defaultHeight;
    this._scaleX = spt._scaleX;
    this._scaleY = spt._scaleY;
    this._rotation = spt._rotation;

    this.scaleX = this._scaleX;
    this.scaleY = this._scaleY;
  }

  public get itemId(): string {
    return this._itemId;
  }

  /*
   * アイテム以外のコンテナなどの幅・高さを指定する
   * 通常の配置アイテムでは不使用
   */
  public setSize(width: number, height: number): void {
    this.width = width;
    this.height = height;
    this.defaultWidth = width;
    this.defaultHeight = height;
  }

  /*
   * size set/get
   */
  public set scaleX(value: number) {
    this._scaleX = value;
    this._width = this.defaultWidth * this._scaleX;

    this.updateScale = true;
  }

  public get scaleX(): number {
    return this._scaleX;
  }

  public set scaleY(value: number) {
    this._scaleY = value;
    this._height = this.defaultHeight * this._scaleY;

    this.updateScale = true;
  }

  public get scaleY(): number {
    return this._scaleY;
  }

  public set width(value: number) {
    this._width = value;
    this._scaleX = this._width / this.defaultWidth;

    this.updateScale = true;
  }

  public get width(): number {
    return this._width;
  }

  public set height(value: number) {
    this._height = value;
    this._scaleY = this._height / this.defaultHeight;

    this.updateScale = true;
  }

  public get height(): number {
    return this._height;
  }

  public set rotation(value: number) {
    this._rotation = value;

    if (value !== 0) {
      this.updateRotation = true;
    }
  }

  public get rotation(): number {
    return this._rotation;
  }

  public get mouseX(): number {
    let flag: boolean = true;
    let tg: SVGSprite = this;

    let tmp: Array<SVGSprite> = [];
    tmp.push(this);

    do {
      if (tg.parent != null) {
        tg = tg.parent;
        tmp.push(tg);
      } else {
        flag = false;
      }
    } while (flag);

    let x: number = 0;
    let base: number = Stage.mouseX - Stage.offsetX;
    // Debugger.text(2, "mouseX/offsetX " + Stage.mouseX + " " + Stage.offsetX);
    let prevTg: SVGSprite = null;
    let totalSc: number = 1;

    tmp = tmp.reverse();

    for (let i: number = 0, ln: number = tmp.length; i < ln; i += 1) {
      tg = tmp[i];

      if (prevTg != null) {
        if (!Number.isNaN(tg.x)) {
          base -= tg.x * totalSc;
          // Debugger.log("#3 " + tg.x + " * " + totalSc);

          // Debugger.log("#4 " + base + " " + tg.scaleX + " " + totalSc);
        } else {
          // enirva.core.debug.Debugger.log('Error! ' + tg.name + ' ' + tg.scaleX);
        }
        // Debugger.log("!>> " + tg.x + " " + tg.scaleX);
        totalSc *= tg.scaleX;
      } else {
        // rootの場合
        // Debugger.log("#1 " + base + " - " + tg.x);
        // Debugger.log("!>>> " + tg.x + " " + tg.scaleX);
        base -= tg.x;
        totalSc *= tg.scaleX;
        // Debugger.log("#2 " + base + " " + tg.scaleX + " " + totalSc);
      }

      prevTg = tg;
    }

    x = base / totalSc;
    // Debugger.log("base = " + base + " sc " + totalSc);

    return x;
  }

  public get mouseY(): number {
    let flag: boolean = true;
    let tg: SVGSprite = this;

    let tmp: Array<SVGSprite> = [];
    tmp.push(this);

    do {
      if (tg.parent != null) {
        tg = tg.parent;
        tmp.push(tg);
      } else {
        flag = false;
      }
    } while (flag);

    let y: number = 0;
    let base: number = Stage.mouseY - Stage.offsetY;
    let prevTg: SVGSprite = null;
    let totalSc: number = 1;

    tmp = tmp.reverse();

    for (let i: number = 0, ln: number = tmp.length; i < ln; i += 1) {
      tg = tmp[i];

      if (prevTg != null) {
        if (!Number.isNaN(tg.y)) {
          base -= tg.y * totalSc;
        }
        // Debugger.log(">> " + tg.name + " " + tg.itemId + " " + tg.y + " " + tg.scaleY);
        totalSc *= tg.scaleY;
      } else {
        // rootの場合
        base -= tg.y;
        // Debugger.log(">>> " + tg.name + " " + tg.itemId + " " + tg.y + " " + tg.scaleY);
        totalSc *= tg.scaleY;
      }

      prevTg = tg;
    }

    y = base / totalSc;

    // Debugger.log("y = " + y + " sc " + totalSc);

    return y;
  }

  /**
   * グローバル座標（SVGルート＝スクロールコンテンツ座標）を、このスプライトの
   * ローカル座標へ変換する。localToGlobalの逆変換で、レイヤ階層を降りながら
   * 各階層の平行移動を引き、累積スケールで正規化する。
   * Stage.offsetX/Yには依存しないため、scrollイベントによるオフセット更新を
   * 待たずに常に正確な値が得られる（ピンチズームの焦点計算などに用いる）。
   * @param pt グローバル座標（SVGルート座標系）
   */
  public globalToLocal(pt: Point): Point {
    let flag: boolean = true;
    let tg: SVGSprite = this;

    const tmp: Array<SVGSprite> = [];
    tmp.push(this);

    do {
      if (tg.parent != null) {
        tg = tg.parent;
        tmp.push(tg);
      } else {
        flag = false;
      }
    } while (flag);

    let baseX: number = pt.x;
    let baseY: number = pt.y;
    let prevTg: SVGSprite = null;
    let totalScX: number = 1;
    let totalScY: number = 1;

    const ordered: Array<SVGSprite> = tmp.reverse();

    for (let i: number = 0, ln: number = ordered.length; i < ln; i += 1) {
      tg = ordered[i];

      if (prevTg != null) {
        if (!Number.isNaN(tg.x)) {
          baseX -= tg.x * totalScX;
        }
        if (!Number.isNaN(tg.y)) {
          baseY -= tg.y * totalScY;
        }
      } else {
        // rootの場合
        baseX -= tg.x;
        baseY -= tg.y;
      }
      totalScX *= tg.scaleX;
      totalScY *= tg.scaleY;

      prevTg = tg;
    }

    return new Point(baseX / totalScX, baseY / totalScY);
  }

  public set alpha(value: number) {
    this._alpha = value;

    if (this.element !== undefined) {
      this.element.style.opacity = this.alpha.toString();
    }
  }

  public get alpha(): number {
    return this._alpha;
  }

  /*
   * Masterで初期化時に使用する関数。
   * 通常は使わない事。
   */
  public initializeAddChild(child: SVGSprite): Object {
    // this.element.append(child.element);
    this.element.appendChild(child.element);

    const rectObj: any = {};

    const rect: DOMRect = child.element.getBoundingClientRect();
    // Debugger.log(" w/h = " + (rect.right - rect.left) + " " + (rect.bottom - rect.top));

    rectObj.root = rect;

    if (child.parent !== this) {
      child.setParent(this);
      this.children.push(child);
    }

    const gList = child.element.querySelectorAll('g');

    for (let i: number = 0; i < gList.length; i += 1) {
      const elem: SVGGElement = gList[i];
      const name: string = elem.getAttribute('name');

      if (name !== undefined && name !== '' && name != null) {
        // wall, hashira_1などの子要素あり
        const crect: DOMRect = $(elem)[0].getBoundingClientRect();
        // const w: number = crect.right - crect.left;
        // const h: number = crect.bottom - crect.top;
        // Debugger.log("child name " + $(elem).attr("name") + " " + w + " " + h);

        rectObj[name] = crect;
      }
    }

    this.removeChild(child);

    return rectObj;
  }

  public addChild(child: SVGSprite): void {
    // var rect:ClientRect = child.element[0].getBoundingClientRect();
    // Debugger.log("w/h = " + (rect.right - rect.left) + " " + (rect.bottom - rect.top));

    if (child.parent !== this) {
      child.setParent(this);
      this.children.push(child);
    } else {
      // Debugger.log("すでにaddChild済");
    }

    if (child.isEmpty) return;

    this.element.appendChild(child.element);

    child.setMouseEvent();
  }

  public addChildBefore(child: SVGSprite): void {
    child.element.parentNode.insertBefore(this.element, child.element);

    // var rect:ClientRect = child.element[0].getBoundingClientRect();
    // Debugger.log("w/h = " + (rect.right - rect.left) + " " + (rect.bottom - rect.top));

    if (child.parent !== this) {
      child.setParent(this);
      this.children.push(child);
    } else {
      // Debugger.log("すでにaddChild済");
    }

    child.setMouseEvent();
  }

  public removeChild(child: SVGSprite): void {
    const tmp: SVGSprite[] = [];

    for (let i: number = 0, ln: number = this.children.length; i < ln; i += 1) {
      if (this.children[i] !== child) {
        tmp.push(this.children[i]);
      }
    }

    this.children = tmp;

    child.remove();
  }

  /*
   * 子要素をすべて削除
   */
  public removeChildren(): void {
    for (let i: number = 0, ln: number = this.children.length; i < ln; i += 1) {
      this.children[i].remove();
    }

    this.children = [];
  }

  public getChildByName(name: string): SVGSprite {
    // const child: JQuery = this.element.find("[name='" + name + "']");
    const child: HTMLElement = this.element.querySelector(`[name="${name}"]`);

    if (child) {
      child.classList.add('svgSprite');
    }
    const spt: SVGSprite = new SVGSprite(child);
    spt.parent = this;
    return spt;
  }

  public getBoundingClientRect(): DOMRect {
    const rect: DOMRect = this.element.getBoundingClientRect();
    return rect;
  }

  /*
   * 画面非表示フラグ
   */
  public set visible(value: boolean) {
    this._visible = value;

    if (value) {
      this.element.style.display = 'block';
    } else {
      this.element.style.display = 'none';
    }
  }

  /*
   * 画面非表示フラグ
   */
  public get visible(): boolean {
    return this._visible;
  }

  /*
   * ローカル座標をグローバル座標に変換する
   */
  public localToGlobal(pt: Point): Point {
    const result: Point = new Point(0, 0);

    let flag: boolean = true;
    let tg: SVGSprite = this;

    let tmp: Array<SVGSprite> = [];
    tmp.push(this);

    do {
      if (tg.parent != null) {
        tg = tg.parent;
        tmp.push(tg);
      } else {
        flag = false;
      }
    } while (flag);

    let baseX: number = 0;
    let baseY: number = 0;
    let prevTg: SVGSprite = null;
    let totalScX: number = 1;
    let totalScY: number = 1;

    tmp = tmp.reverse();

    for (let i: number = 0, ln: number = tmp.length; i < ln; i += 1) {
      tg = tmp[i];

      if (prevTg != null) {
        // Debugger.log("#3 " + tg.x + " * " + totalScX);
        baseX += tg.x * totalScX;
        baseY += tg.y * totalScY;
        totalScX *= tg.scaleX;
        totalScY *= tg.scaleY;
        // Debugger.log("#4 " + baseX + " " + tg.scaleX + " " + totalScX);
      } else {
        // rootの場合
        // Debugger.log("#1 " + baseX + " - " + tg.x);
        baseX += tg.x;
        baseY += tg.y;
        totalScX *= tg.scaleX;
        totalScY *= tg.scaleY;
        // Debugger.log("#2 " + baseX + " " + tg.scaleX + " " + totalScX);
      }

      prevTg = tg;
    }

    baseX += pt.x * totalScX;
    baseY += pt.y * totalScY;

    // Debugger.log("x = " + baseX + " sc " + totalScX);

    result.x = baseX;
    result.y = baseY;

    return result;
  }

  /*
   * 描画の更新
   */
  public update(): void {
    // 稀にundefinedが代入される事があるので、
    // 一応、こちらで回避するよう修正
    const x: number = this.x === undefined ? 0 : this.x;
    const y: number = this.y === undefined ? 0 : this.y;

    const scX = this.scaleX * (this.isReverse ? -1 : 1);
    const scY = this.scaleY;
    let mtx: string;

    // Debugger.text(0, this.x);
    // Debugger.text(1, this.y);
    // Debugger.text(2, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX);
    // Debugger.text(3, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY);

    if (this.updateRotation || this._rotation !== 0) {
      this.mtxScale.reset();
      this.mtxScale.n11 = scX;
      this.mtxScale.n22 = scY;

      const r: number = (this._rotation / 180) * Math.PI;

      this.mtxRot.reset();
      this.mtxRot.n11 = Math.cos(r);
      this.mtxRot.n12 = -Math.sin(r);
      this.mtxRot.n21 = Math.sin(r);
      this.mtxRot.n22 = Math.cos(r);

      this.mtxRot.multiply(this.mtxScale);
      this.mtxRot.n13 = x;
      this.mtxRot.n23 = y;

      mtx = this.mtxRot.svgMatrix();

      this.updateRotation = false;
    } else {
      mtx = `matrix(${scX}, 0, 0, ${scY}, ${x}, ${y})`;
    }

    // スケールのNaN防止
    if (Number.isNaN(scX) || Number.isNaN(scY)) return;

    if (this.element) {
      this.element.setAttribute('transform', mtx);
    }

    if (this.updateScale) {
      // var def:JQuery = SVGSpriteManager.instance.getDefineItem(this.itemId);

      if (this.element !== undefined) {
        // 定義タグがあれば、線幅を更新する

        this.udpateLineWidth(this.scaleX);
      } else if (this.bindParentDefine) {
        if (this.parent !== undefined) {
          this.parent.udpateLineWidth(this.scaleX);
        }
      }

      this.updateScale = false;
    }
  }

  public show():void {
    this.element.style.display = 'block';
  }

  public hide():void {
    this.element.style.display = 'none';
  }

  public setScrollEvent(handler):void {
    this.element.addEventListener('wheel', this.wheelHandler = (e:WheelEvent) => {
      handler(e);
    });
  }

  private udpateLineWidth(scX: number): void {
    // var sc_x:number = this.scaleX;
    // var sc_y:number = this.scaleY;

    if (this.defineTag === undefined) return;

    for (let i:number = 0; i < this.defineTag.length; i += 1) {
      const define:SVGGElement = this.defineTag[i];

      // 壁アイテムの場合は伸縮させない
      if (define.getAttribute('stroke-width') !== undefined) {
        let tick: number = parseInt(define.getAttribute('stroke-width'), 10);

        tick = 1 / scX;
        define.setAttribute('stroke-width', tick.toString());
      }
    }

    // this.defineTag.find('path').each((index: number, elem: Element): void => {
    //   // Debugger.log(">> " + $(elem).attr("stroke-width"));

    //   // 壁アイテムの場合は伸縮させない
    //   if ($(elem).attr('stroke-width') !== undefined) {
    //     let tick: number = parseInt($(elem).attr('stroke-width'), 10);

    //     tick = 1 / scX;
    //     $(elem).attr('stroke-width', tick);

    //     // Debugger.text(index, tick);
    //   }
    // });
  }

  public unscaleStrokeWidth(scale: number): void {
    // Debugger.log("path is " + this.defineTag.find("path").length);
    if (this.element === undefined) return;

    const newWidth: number = 1 / scale;

    const pathList = this.element.querySelectorAll('path');

    for (let i: number = 0; i < pathList.length; i += 1) {
      // Debugger.log(">> " + $(elem).attr("stroke-width"));

      const elem: SVGPathElement = pathList[i];

      // 壁アイテムの場合は伸縮させない
      if (elem.getAttribute('stroke-width') !== undefined) {
        elem.setAttribute('stroke-width', newWidth.toString());

        // Debugger.text(index, tick);
      }
    }
  }

  public remove(): void {
    this.deleteEnterFrame();
    this.parent = null;
    this.removeAllEventListener();

    if (this.isEmpty) return;

    if (this.element !== undefined) {
      this.element.remove();
    }

    if (this.defineTag !== undefined) {
      // this.defineTag.remove();

      for (let i:number = 0; i < this.defineTag.length; i += 1) {
        this.defineTag[i].remove();
      }

      this.defineTag = undefined;
    }
    // SVGSpriteManager.instance.removeItem(this._itemId);

    if (this.doubleClickListenerFunc !== undefined) {
      window.removeEventListener('mouseup', this.doubleClickListenerFunc);
      this.doubleClickListenerFunc = null;
    }
  }

  private setMouseEvent(): void {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;

    if (ua.isMobile || ua.isTablet) {
      this.element.removeEventListener('touchstart', this.mouseDownHandler);
      this.element.addEventListener(
        'touchstart',
        this.mouseDownHandler = (e: TouchEvent) => {
          // e.preventDefault();
          this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_DOWN));
        },
      );

      this.element.removeEventListener('touchend', this.mouseUpHandler);
      this.element.addEventListener(
        'touchend',
        this.mouseUpHandler = (e: TouchEvent) => {
          // e.preventDefault();
          this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_UP));
        },
      );
    } else {
      this.element.removeEventListener('mousedown', this.mouseDownHandler);
      this.element.addEventListener(
        'mousedown',
        this.mouseDownHandler = (e: MouseEvent) => {
          // e.preventDefault();
          this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_DOWN));
        },
      );

      this.element.removeEventListener('mouseup', this.mouseUpHandler);
      this.element.addEventListener(
        'mouseup',
        this.mouseUpHandler = (e: TouchEvent) => {
          e.preventDefault();
          this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_UP));
        },
      );
    }

    this.element.removeEventListener('click', this.clickHandler);
    this.element.addEventListener(
      'click',
      this.clickHandler = (e: TouchEvent) => {
        // e.preventDefault();
        this.dispatchEvent(new marietta.webcad.flash.events.MouseEvent(marietta.webcad.flash.events.MouseEvent.CLICK));
      },
    );
  }

  private setParent(parent:SVGSprite):void {
    this.parent = parent;
  }
}
